// @core/api/endpoints/billing/list_credit_grants.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCreditGrantsResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List credit grants for billing account
 * Returns all credit grants for a billing account with optional filtering by active status. Shows remaining and used amounts.
 */
export async function ListCreditGrants(
  billingAccountId: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCreditGrantsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:billingAccountId/credits`;
  requestPath = requestPath.replace(':billingAccountId', encodeURIComponent(billingAccountId));
  const requestOptions = options;
  return client.get<ListCreditGrantsResponse>(requestPath, { ...requestOptions, params });
}
